import { callFunction } from './functionsService';

export async function getMetalPrice(metal = 'XAU', currency = 'USD') {
  return callFunction('getMetalPrice', { metal, currency });
}

export async function getMetalPrices(metals = ['XAU', 'XAG', 'XPT'], currency = 'USD') {
  return callFunction('getMetalPrices', { metals, currency });
}
